"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _analyticsService = _interopRequireDefault(require("./analyticsService"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var _instance;
var init = function init(window) {
  _instance = new _analyticsService["default"](window);
  return _instance;
};
if (typeof window !== 'undefined') {
  init(window);
}
var _default = exports["default"] = {
  /**
   * Get the Analytics reporter
   * @returns {Analytics}
   */
  getInstance: function getInstance() {
    return _instance;
  },
  /**
   * Initialize Analytics with window (unit test only)
   * @param window - The 'window'. Should support addEventListener
   * @returns a new instance of Analytics
   */
  init: init
};